import * as React from 'react';

function CloseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke="black" />
      <path
        d="M6 6L10 10M6 10L10 6"
        stroke="#121519"
        strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
}

export default React.memo(CloseIcon);
